import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';


@Component({
  selector: 'app-discipline-master',
  templateUrl: './discipline-master.component.html',
  styleUrls: ['./discipline-master.component.css']
})
export class DisciplineMasterComponent implements OnInit {

  constructor(private examService:ExamService,private lookupService: LookupService, private globalHelper: GlobalHelper,     private spinnerService: Ng4LoadingSpinnerService) { }
  

        // Get Evaluation Critetia

        ExamMasterModle = {
          Discipline: '',
          DisciplineID: 0,
          IsActive: true,
      };

      DisciplineMasterList:any;
      GetDisciplineMaster  () {
          this.spinnerService.show();
          this.examService.GetDisciplineMaster().subscribe( (response)=> {
              this.DisciplineMasterList = response.DisciplineMasterList;
              this.spinnerService.hide();
          });
      };

      // Save Evaluation Critetia      

      Submitted = false;
      SaveDisciplineMaster  (valid) {
          this.Submitted = true;
          if (valid) {
              
              this.examService.SaveDisciplineMaster(JSON.stringify(this.ExamMasterModle)).subscribe( (response)=> {
                
                  this.globalHelper.CheckActionStatus(response);
                  if (this.ExamMasterModle.DisciplineID == 0 && response.webResponse.Status) {
                      this.Clear();
                  }
                  if (response.webResponse.Status) {
                      this.GetDisciplineMaster();
                  }

              })
          }
      };


      Clear  () {
          this.ExamMasterModle.DisciplineID = 0;
          this.ExamMasterModle.Discipline = '';
          this.ExamMasterModle.IsActive = true;
          this.Submitted = false;
      }



      Edit  (obj) {
          this.ExamMasterModle.DisciplineID = obj.DisciplineID;
          this.ExamMasterModle.Discipline = obj.Discipline;
          this.ExamMasterModle.IsActive = obj.IsActive;

      }


      // Mark Active/InActive

      DisciplineMasterActive  (item) {
          this.Clear();
          this.ExamMasterModle.DisciplineID = item.DisciplineID;
          this.ExamMasterModle.IsActive = item.IsActive == true ? false : true;

          this.examService.DisciplineMasterActive(JSON.stringify(this.ExamMasterModle)).subscribe( (data)=> {
              this.GetDisciplineMaster();
              this.globalHelper.CheckActionStatus(data);



          });
      }


    

  ngOnInit() {
    this.GetDisciplineMaster();
  }

}
